module.exports = __webpack_public_path__ + "img/35.c1805d88.png";